/* BCS: picking a size photo picks that size (and its price). v29 */
(function () {
  var form = document.querySelector('form[id^="product-form-main-"]');
  var gallery = document.querySelector('.product-gallery');
  if (!form || !gallery) return;
  var handle = location.pathname.split('/products/')[1];
  if (!handle) return;
  handle = handle.split(/[/?#]/)[0];
  var mediaToVariant = {};
  var variants = [];
  var busy = false;

  function checkedValues() {
    var vals = [];
    Array.prototype.forEach.call(document.querySelectorAll('input.block-swatch__radio:checked, input.color-swatch__radio:checked'), function (inp) {
      var pos = parseInt(inp.getAttribute('data-option-position'), 10) - 1;
      var l = document.querySelector('label[for="' + inp.id + '"]');
      vals[pos] = l ? l.textContent.trim().toLowerCase() : '';
    });
    return vals;
  }

  function isCurrent(v) {
    var c = checkedValues();
    return (v.options || []).every(function (val, i) {
      return c[i] === undefined || c[i] === String(val).trim().toLowerCase();
    });
  }

  // When the customer picks a size, the theme moves the photo itself: ignore that move.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input.block-swatch__radio, input.color-swatch__radio, select')) {
      busy = true;
      clearTimeout(window.__bcsVmT);
      window.__bcsVmT = setTimeout(function () { busy = false; }, 900);
    }
  }, true);

  // Picking a size shows that size's photo (the theme's own switch was not firing).
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    var fm = v && v.featured_media;
    if (!fm) return;
    setTimeout(function () {
      var cur = gallery.querySelector('.product-gallery__carousel-item.is-selected');
      if (cur && cur.getAttribute('data-media-id') === String(fm.id)) return;
      busy = true;
      clearTimeout(window.__bcsVmT);
      window.__bcsVmT = setTimeout(function () { busy = false; }, 900);
      var th = gallery.querySelector('.product-gallery__thumbnail[data-media-id="' + fm.id + '"]');
      if (th) { th.click(); return; }
      var car = gallery.querySelector('.product-gallery__carousel');
      var fl = window.Flickity && car && window.Flickity.data(car);
      if (fl) fl.selectCell('[data-media-id="' + fm.id + '"]');
    }, 150);
  });

  function labelFor(input) {
    var l = document.querySelector('label[for="' + input.id + '"]');
    return l;
  }

  function selectVariant(v) {
    busy = true;
    (v.options || []).forEach(function (val, i) {
      var inputs = document.querySelectorAll('input.block-swatch__radio[data-option-position="' + (i + 1) + '"], input.color-swatch__radio[data-option-position="' + (i + 1) + '"]');
      Array.prototype.forEach.call(inputs, function (inp) {
        var l = labelFor(inp);
        var txt = l ? l.textContent.trim() : '';
        if (txt.toLowerCase() === String(val).trim().toLowerCase() && !inp.checked) {
          if (l) l.click(); else inp.click();
        }
      });
      var s = document.querySelector('select[data-option-position="' + (i + 1) + '"]');
      if (s && s.value !== val) { s.value = val; s.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    clearTimeout(window.__bcsVmT);
    window.__bcsVmT = setTimeout(function () { busy = false; }, 900);
  }

  function onMedia(mediaId) {
    if (busy || !mediaId) return;
    var vid = mediaToVariant[mediaId];
    if (!vid) return;
    var v = variants.filter(function (x) { return x.id === vid; })[0];
    if (v && !isCurrent(v)) selectVariant(v);
  }

  fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
    variants = p.variants || [];
    if (variants.length < 2) return;
    variants.forEach(function (v) {
      if (v.featured_media && !mediaToVariant[v.featured_media.id]) mediaToVariant[v.featured_media.id] = v.id;
    });
    if (!Object.keys(mediaToVariant).length) return;

    gallery.addEventListener('click', function (e) {
      var t = e.target.closest('.product-gallery__thumbnail[data-media-id]');
      if (t) setTimeout(function () { onMedia(t.getAttribute('data-media-id')); }, 50);
    });

    var items = gallery.querySelectorAll('.product-gallery__carousel-item[data-media-id]');
    var mo = new MutationObserver(function (list) {
      list.forEach(function (m) {
        var el = m.target;
        if (el.classList.contains('is-selected')) onMedia(el.getAttribute('data-media-id'));
      });
    });
    Array.prototype.forEach.call(items, function (el) {
      mo.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }).catch(function () {});
})();
